module.exports = "md-divider {\n  margin: 3px;\n}\n.downloadbtn{\n  /*max-width: 30%;*/\n  margin-bottom: -15%;\n}\n.downloadbtn2{\n  /*max-width: 30%;*/\n  margin-bottom: -15%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/my-downloads/my-downloads.component.css
// module id = ./src/app/user/my-downloads/my-downloads.component.css
// module chunks = main